<template>
  <div class="form-group position-relative">
    <label :for="id" v-if="label && type !== 'checkbox'" class="mb-0">{{label}}</label>

    <select v-if="type === 'select'" :disabled="readOnly"
            class="form-control"
            :class="[{'is-invalid' : error}, classes]"
            :id="id"
            :ref="name"
            @input="$emit('input', $event.target.value)">
      <option v-if="options">Select</option>
      <option v-if="label == 'סטטוס'" value="1">חדש</option>
      <option v-if="options" v-for="option in options" :value="option.key">
        {{option.value ? option.value : option.key}}
      </option>
      <slot v-if="!options"></slot>
    </select>

    <multiselect v-else-if="type === 'multiselect'"
                 dir="rtl"
                 :id="id"
                 :ref="name"
                 :options="options"
                 track-by="key"
                 @input="emitValue($event)"
                 label="value"
                 v-model="selected"
                 :multiple="true"
                 :readOnly="readOnly"
                 :placeholder="$t('orders.selectDepartments')"
                 :selectLabel="$t('orders.select')"
                 :deselectLabel="$t('orders.remove')"
                 :group-values="isGrouped ? 'values' : null"
                 :group-label="isGrouped ? 'label' : null"
    />

    <div class="slider-checkbox" v-else-if="type === 'checkbox' || type === 'radio'">
      <input :type="type"
             :id="id"
             :name="name"
             :checked="val"
             :ref="name"
             :value="val"
             @change="$emit('input', $event.target.checked ? '1' : '0')">
      <label :for="id">{{label}}</label>
    </div>

    <textarea v-else-if="type === 'textarea' "
              :id="id"
              class="form-control w-100"
              :class="[{'is-invalid' : error}, classes]"
              :rows="rows ? rows : 1"
              :cols="cols ? cols : 4"
              :ref="name"
              :readOnly="readOnly"
              :maxlength="maxlength"
              @input="$emit('input', $event.target.value)">
            </textarea>

    <datepicker v-else-if="type === 'date'"
                :ref="name"
                :language="lang"
                input-class="form-control"
                :value="date"
                :disabled-dates="disabledDates"
                format="dd/MM/yyyy">
    </datepicker>

    <input v-else
           :type="type ? type : 'text'"
           class="form-control"
           :class="[{'is-invalid' : error}, classes]"
           :id="id ? id : name"
           :ref="name"
           :readOnly="readOnly"
           :name="name"
           @input="$emit('input', $event.target.value)"
    >


    <small v-if="error" class="text-danger position-absolute">{{ error }}</small>
  </div>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import Datepicker from 'vuejs-datepicker'
  import {he} from 'vuejs-datepicker/src/locale'

  export default {
    components: {Multiselect, Datepicker},

    name: 'formControl',
    props: {
      label: String,
      name: String,
      type: String,
      id: [String, Number],
      maxlength: String,
      classes: String,
      val: {
        type: [String, Number, Boolean],
        default: ''
      },
      html: {
        type: [String, Number, Boolean],
        default: ''
      },
      error: {
        type: String,
        default: null
      },
      options: {
        type: [Array, String, Object],
        default: null
      },
      checked: null,
      readOnly: {
        type: [Boolean],
        default: false
      },

      rows: String,
      cols: String,
    },

    $_veeValidate: {
      value() {
        return this.$refs[this.name].value
      },
      name() {
        return this.name
      }
    },
    mounted() {

      if (this.type === 'checkbox') {
        this.$refs[this.name].value = this.val === null ? 0 : 1;
        this.$refs[this.name].checked = this.val === 1
      }

      if (this.val) {
        if (this.type === 'multiselect') {
          let selected = this.val.toString().split(',');
          selected = selected.map(s => isNaN(s) ? s : Number(s));
          const flatOptions = this.isGrouped 
            ? this.options.reduce((acc, group) => [...acc, ...group.values], [])
            : this.options;
            
          for (let i in flatOptions) {
            const key = flatOptions[i].key;
            let isMatched = selected.includes(key);
            if (!isMatched && this.name === 'dashboard_statuses' && typeof key === 'string' && key.includes('_')) {
              const baseId = Number(key.split('_')[0]);
              isMatched = selected.includes(baseId) || selected.includes(baseId.toString());
            }
            if (isMatched) {
              this.selected.push(flatOptions[i])
            }
          }
        } else if (this.type === 'date') {
          this.date = this.val
        } else if (this.type === 'textarea') {

         this.$refs[this.name].value = this.val
          let d = this.$refs[this.name].value.split(',').join('<br />')
          $('#cleanTextArea').append(d)
        } else {
          this.$refs[this.name].value = this.val
        }
        this.$emit('input', this.val)
      }
    },
    data() {
      return {
        lang: he,
        date: '',
        disabledDates: {to: new Date()},
        selected: [],
      }
    },
    computed: {
      isGrouped() {
        return this.options && this.options.length > 0 && this.options[0].values;
      }
    },

    methods: {
      emitValue(e) {
        let str = []
        for (let i in this.selected) {
          str.push(this.selected[i].key)
        }
        this.$emit('input', str.join(','))
      },
    },

    /**
     * Used for viewOne messages change
     */
    watch: {
      options(newOptions) {
        if (this.type === 'multiselect' && this.val) {
          this.selected = []
          let selected = []
          if (typeof this.val === 'string') {
            selected = this.val.toString().split(',').map(s => isNaN(s) ? s : Number(s));
          } else if (Array.isArray(this.val)) {
            selected = this.val.map(s => isNaN(s) ? s : Number(s));
          }
          const flatOptions = this.isGrouped 
            ? newOptions.reduce((acc, group) => [...acc, ...group.values], [])
            : newOptions;

          for (let i in flatOptions) {
            const key = flatOptions[i].key;
            let isMatched = selected.includes(key);
            if (!isMatched && this.name === 'dashboard_statuses' && typeof key === 'string' && key.includes('_')) {
              const baseId = Number(key.split('_')[0]);
              isMatched = selected.includes(baseId) || selected.includes(baseId.toString());
            }
            if (isMatched) {
              this.selected.push(flatOptions[i])
            }
          }
        }
      },
      val(newVal) {
        if (newVal) {
          if (this.type === 'multiselect') {
            // Clear and repopulate multiselect
            this.selected = []
            let selected = []
            if (typeof newVal === 'string') {
              selected = newVal.toString().split(',').map(s => isNaN(s) ? s : Number(s));
            } else if (Array.isArray(newVal)) {
              selected = newVal.map(s => isNaN(s) ? s : Number(s));
            }
            const flatOptions = this.isGrouped 
              ? this.options.reduce((acc, group) => [...acc, ...group.values], [])
              : this.options;

            for (let i in flatOptions) {
              const key = flatOptions[i].key;
              let isMatched = selected.includes(key);
              if (!isMatched && this.name === 'dashboard_statuses' && typeof key === 'string' && key.includes('_')) {
                const baseId = Number(key.split('_')[0]);
                isMatched = selected.includes(baseId) || selected.includes(baseId.toString());
              }
              if (isMatched) {
                this.selected.push(flatOptions[i])
              }
            }
          } else if (this.type !== 'date') {
            if (this.$refs[this.name]) {
              this.$refs[this.name].value = newVal
            }
          }
        }
      }
    }
  }


</script>


<style lang="scss" scoped>
  /*https://codepen.io/Qvcool/pen/bdzVYW*/

  $checked-color: #1877c1;
  $unchecked-color: #888;

  .slider-checkbox {
    display: inline-flex;
    text-align: left;
    align-items: center;
    position: relative;

    input {
      margin: 0px;
      margin-top: 1px;
      cursor: pointer;
      opacity: 0;
      -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
      filter: alpha(opacity=0);
      -moz-opacity: 0;
      -khtml-opacity: 0;
      opacity: 0;
      position: absolute;
      z-index: 1;
      top: 0px;
      left: 0px;
      background: red;
      width: 40px;
      height: 20px;

      &:checked + label {
        &:before {
          background-color: $checked-color;
          content: "\f00c";
          padding-left: 6px;
        }

        &:after {
          left: 21px;
        }
      }
    }

    label {
      position: relative;
      padding-left: 46px;

      &:before, &:after {
        position: absolute;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        transition: background-color 0.3s, left 0.3s;
      }

      &:before {
        content: "\f00d";
        color: #fff;
        box-sizing: border-box;
        font-family: 'FontAwesome', sans-serif;
        padding-left: 23px;
        font-size: 12px;
        line-height: 20px;
        background-color: $unchecked-color;
        left: 0px;
        top: 0px;
        height: 20px;
        width: 40px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
      }

      &:after {
        content: "";
        letter-spacing: 20px;
        background: #fff;
        left: 1px;
        top: 1px;
        height: 18px;
        width: 18px;
      }
    }
  }


</style>

